import stripeService from '../../services/stripeService'

class TopupForm {
  onSubmit = async (): Promise<{ clientSecret: string }> => {
    return stripeService.topup()
  }
}

export default new TopupForm()
